/** フッターと同系統の下層ページコンテンツ面 */
export const SUBPAGE_SURFACE = '#F2F2F0';
export const SUBPAGE_SURFACE_HOVER = '#E8E6E2';
export const SUBPAGE_SURFACE_BORDER = '#D8D6D0';
